import { useState } from 'react';

export default function CTA() {
  const [showLeadForm, setShowLeadForm] = useState(false);

  const handleLeadFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);
    try {
      await fetch('https://readdy.ai/api/form/d5pr1vihs78ip537014g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as any).toString(),
      });
      form.reset();
      setShowLeadForm(false);
    } catch (error) {
      // silent
    }
  };

  return (
    <>
      <section className="py-24 bg-gradient-to-br from-blue-700 to-[#0a0f1e] text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: 'linear-gradient(rgba(255,255,255,0.2) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.2) 1px, transparent 1px)',
            backgroundSize: '60px 60px'
          }}
        ></div>
        <div className="absolute top-0 right-0 w-96 h-96 bg-blue-400/20 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-indigo-400/20 rounded-full filter blur-3xl"></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-2 mb-6">
              <i className="ri-robot-line text-blue-300 text-sm"></i>
              <span className="text-sm font-medium text-blue-200">The Intelligent Outsourcing Partner</span>
            </div>
            <h2 className="text-4xl sm:text-5xl font-bold mb-6">
              Ready to Operate Smarter?
            </h2>
            <p className="text-xl mb-10 opacity-90 leading-relaxed">
              Join hundreds of forward-thinking companies who've replaced outdated outsourcing with AI-powered operations. Get a free consultation and see exactly how much you can save — and gain.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
              <button
                onClick={() => setShowLeadForm(true)}
                className="bg-white text-blue-700 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-50 transition-all transform hover:scale-105 whitespace-nowrap shadow-xl cursor-pointer"
              >
                Get Free Consultation
              </button>
              <a
                href="/contact"
                className="border-2 border-white/40 hover:border-white hover:bg-white/10 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap"
              >
                Talk to an Expert
              </a>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                { icon: 'ri-robot-2-line', title: 'AI-First', sub: 'Every solution built on AI' },
                { icon: 'ri-money-dollar-circle-line', title: '60% Savings', sub: 'Average cost reduction' },
                { icon: 'ri-line-chart-line', title: 'Scalable', sub: 'Grow or shrink on demand' },
                { icon: 'ri-shield-check-line', title: 'Compliant', sub: 'SOC 2, HIPAA, PCI-DSS' },
              ].map((item, i) => (
                <div key={i} className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 text-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg mb-4 mx-auto">
                    <i className={`${item.icon} text-2xl`}></i>
                  </div>
                  <div className="text-xl font-bold mb-1">{item.title}</div>
                  <p className="text-sm opacity-80">{item.sub}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {showLeadForm && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-md w-full p-8 relative shadow-2xl">
            <button
              onClick={() => setShowLeadForm(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Free Consultation</h2>
            <p className="text-gray-600 mb-6">Schedule your free consultation and receive a custom AI-powered proposal within 24 hours.</p>
            <form id="cta-lead-form" data-readdy-form onSubmit={handleLeadFormSubmit} className="space-y-4">
              <div>
                <label htmlFor="cta-name" className="block text-sm font-medium text-gray-700 mb-1">Full Name *</label>
                <input type="text" id="cta-name" name="name" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" />
              </div>
              <div>
                <label htmlFor="cta-email" className="block text-sm font-medium text-gray-700 mb-1">Email Address *</label>
                <input type="email" id="cta-email" name="email" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" />
              </div>
              <div>
                <label htmlFor="cta-company" className="block text-sm font-medium text-gray-700 mb-1">Company Name</label>
                <input type="text" id="cta-company" name="company" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" />
              </div>
              <div>
                <label htmlFor="cta-budget" className="block text-sm font-medium text-gray-700 mb-1">Monthly Budget Range</label>
                <select id="cta-budget" name="budget" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm">
                  <option value="">Select budget range</option>
                  <option value="Under $5,000">Under $5,000</option>
                  <option value="$5,000 - $15,000">$5,000 - $15,000</option>
                  <option value="$15,000 - $30,000">$15,000 - $30,000</option>
                  <option value="$30,000 - $50,000">$30,000 - $50,000</option>
                  <option value="Over $50,000">Over $50,000</option>
                </select>
              </div>
              <div>
                <label htmlFor="cta-timeline" className="block text-sm font-medium text-gray-700 mb-1">When do you need to start?</label>
                <select id="cta-timeline" name="timeline" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm">
                  <option value="">Select timeline</option>
                  <option value="Immediately">Immediately</option>
                  <option value="Within 2 weeks">Within 2 weeks</option>
                  <option value="Within 1 month">Within 1 month</option>
                  <option value="Within 3 months">Within 3 months</option>
                  <option value="Just exploring">Just exploring</option>
                </select>
              </div>
              <button type="submit" className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 transition-colors font-semibold whitespace-nowrap shadow-lg">
                Schedule Free Consultation
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
